/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {

  $.bindTooltips = function() {
    const tooltipElements = Array.prototype.slice.call(document.querySelectorAll('.has-tip'));
    if (tooltipElements.length === 0) {
      return;
    }
    return tooltipElements.map(function(el) {
      // generate html from title attr
      let value = '';

      if (el.attributes['title']) {
        ({
          value
        } = el.attributes['title']);
      } else {
        ({
          value
        } = el.attributes['data-original-title']);
      }

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = value;

      // call tippy
      return tippy(el, {
            html: tempDiv, position: 'top', duration: 0, flipDuration: 0,
            popperOptions: {
              modifiers: {
                flip: {
                  enabled: false
                }
              }
            }
          }
      );
    });
  };

  return $.bindTooltips();
});
